export class DeviceModel {
    public idDevice: number;
    public assetNumber: string;
    public idDesignatedHealthUnit: number;
    public idDeviceType: number;
    public macAddress: string;
    public datetimeinclusion: Date;
}